export const AUTH = "/auth";
export const VERIFY_EMAIL = "/verify";
export const FORGET_PASSWORD = "/forget-password";
export const UPDATE_PASSWORD = "/update-password";
export const SIGN_UP = "/sign-up";

export const HOME = "/";
export const HOMEPAGE = "/homepage"
export const DASHBOARD = "/dashboard/:id?";
export const RESEARCH = "/research/:id?";



